
import React from 'react';
import Chart from 'chart.js/auto';

class SpeedTestChart extends React.Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
        this.chartInstance = null;

      
        this.state = {
            speedTestData: [],
            isLoading: true,
            error: null,
            timeRange: 4, // Default to 4 weeks
        };

       
        this.handleTimeRangeChange = this.handleTimeRangeChange.bind(this);
    }

    componentDidMount() {
        this.fetchData();
      
        this.interval = setInterval(() => this.fetchData(), 60000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        if (this.chartInstance) {
            this.chartInstance.destroy();
        }
    }

    //  Update 'fetchData' to use the 'timeRange' from state
    async fetchData() {
        const { androidId } = this.props;
        const { timeRange } = this.state; // Get timeRange from state
        const serverUrl = process.env.REACT_APP_API_SERVER_URL || '';

        let apiUrl = '';
        if (timeRange === 'today') {
            apiUrl = `${serverUrl}/maiApi/device/${androidId}/speedtest-history?days=1`;
        } else {
            apiUrl = `${serverUrl}/maiApi/device/${androidId}/speedtest-history?weeks=${timeRange}`;
        }

        try {
            const response = await fetch(apiUrl);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            let data = await response.json();
            if (!Array.isArray(data)) {
                data = [];
            }

            console.log('[MAI Speed test] Backend OK — GET speedtest-history succeeded:', apiUrl);

            if (timeRange === 'today') {
                const timeZone = 'America/Chicago'; // CST/CDT
                const formatter = new Intl.DateTimeFormat('en-US', {
                    timeZone,
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
                const partsToKey = (date) => {
                    const parts = formatter.formatToParts(date);
                    const y = parts.find(p => p.type === 'year')?.value;
                    const m = parts.find(p => p.type === 'month')?.value;
                    const d = parts.find(p => p.type === 'day')?.value;
                    return `${y}-${m}-${d}`;
                };
                const todayKey = partsToKey(new Date());
                data = data.filter(item => {
                    const dt = new Date(item.date_time);
                    if (isNaN(dt.getTime())) return false;
                    return partsToKey(dt) === todayKey;
                });
            }

            // Ensure chronological order for x-axis
            data.sort((a, b) => new Date(a.date_time) - new Date(b.date_time));

            if (data.length === 0) {
                console.log('[MAI Speed test] No data: no speed test points for this device/range (chart will be empty).');
            } else {
                console.log(`[MAI Speed test] Chart will show ${data.length} point(s).`);
            }

            this.setState({ speedTestData: data, isLoading: false });
        } catch (e) {
            this.setState({ error: e.message, isLoading: false });
            console.warn('[MAI Speed test] GET speedtest-history failed:', e?.message || e);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        
        if (prevState.speedTestData !== this.state.speedTestData) {
            this.renderChart();
        }
    }
    
   
    handleTimeRangeChange(newRange) {
        
        this.setState({ timeRange: newRange, isLoading: true }, () => {
            this.fetchData();
        });
    }


    renderChart() {
        if (this.chartInstance) {
            this.chartInstance.destroy(); 
        }
        
        const { speedTestData } = this.state;
        const labels = speedTestData.map(d => new Date(d.date_time).toLocaleString());
        const downloadData = speedTestData.map(d => parseFloat(d.download_mbps) || 0);
        const uploadData = speedTestData.map(d => parseFloat(d.upload_mbps) || 0);
        const pingData = speedTestData.map(d => d.ping_ms);
        
        this.chartInstance = new Chart(this.chartRef.current, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Download (Mbps)',
                        data: downloadData,
                        borderColor: 'rgb(75, 192, 192)',
                        yAxisID: 'yMbps',
                        tension: 0.1
                    },
                    {
                        label: 'Upload (Mbps)',
                        data: uploadData,
                        borderColor: 'rgb(54, 162, 235)',
                        yAxisID: 'yMbps',
                        tension: 0.1
                    },
                    {
                        label: 'Ping (ms)',
                        data: pingData,
                        borderColor: 'rgb(255, 99, 132)',
                        yAxisID: 'yPing',
                        tension: 0.1
                    }
                ]
            },
            options: {
                 scales: {
                    yMbps: {
                        type: 'linear',
                        position: 'left',
                        title: { display: true, text: 'Speed (Mbps)' }
                    },
                    yPing: {
                        type: 'linear',
                        position: 'right',
                        title: { display: true, text: 'Ping (ms)' },
                        grid: { drawOnChartArea: false }
                    }
                }
            }
        });
    }

    
    render() {
        const { isLoading, error } = this.state;

        return (
            <div>
                {/* The Filter Buttons */}
                <div className="mb-4 text-center">
                    <button onClick={() => this.handleTimeRangeChange('today')} className="bg-blue-500 text-white font-bold py-2 px-4 rounded mr-2">Today</button>
                    <button onClick={() => this.handleTimeRangeChange(1)} className="bg-blue-500 text-white font-bold py-2 px-4 rounded mr-2">1 Week</button>
                    <button onClick={() => this.handleTimeRangeChange(4)} className="bg-blue-500 text-white font-bold py-2 px-4 rounded mr-2">4 Weeks</button>
                    <button onClick={() => this.handleTimeRangeChange(8)} className="bg-blue-500 text-white font-bold py-2 px-4 rounded">8 Weeks</button>
                </div>

                {/* Loading and Error Messages */}
                {isLoading && <p className="text-center">Loading Chart Data...</p>}
                {error && <p className="text-center text-red-500">Error: {error}</p>}

                {/* The Chart Canvas */}
                <canvas ref={this.chartRef} />
            </div>
        );
    }
}

export default SpeedTestChart;